<template>
  <div>
    <apexchart ref="barChart" class="apex-charts" dir="ltr" height="250" :series="chartData.series"
      :options="chartData.chartoptions"></apexchart>
  </div>
</template>

<script>
export default {
  props: {
    year: Number,
  },
  data () {
    return {
      chartData: {
        series: [
          {
            name: "Incidents",
            data: [],
          },
          {
            name: "Accidents",
            data: [],
          },
        ],
        chartoptions: {
          chart: {
            height: 250,
            type: "bar",
            toolbar: {
              show: false,
            },
          },
          colors: ["#556ee6", "#f1b44c"],
          dataLabels: {
            enabled: false,
          },
          stroke: {
            curve: "smooth",
            width: 2,
            colors: ["#fff"],
          },

          xaxis: {
            categories: [
              "Jan",
              "Feb",
              "Mar",
              "Apr",
              "May",
              "Jun",
              "Jul",
              "Aug",
              "Sep",
              "Oct",
              "Nov",
              "Dec",
            ],
          },
          markers: {
            size: 3,
            strokeWidth: 3,

            hover: {
              size: 4,
              sizeOffset: 2,
            },
          },
          legend: {
            position: "top",
            horizontalAlign: "center",
          },
        },
      },
      selection: "all",
    };
  },
  methods: {
    updateData: function (timeline) {
      this.selection = timeline;
      switch (timeline) {
        case "day":
          break;
        case "week":
          break;
        case "month":
          break;
        case "all":
          break;
        default:
      }
    },

    async generateChartData () {
      const chartIncidentsTempArray = [];
      const chartAccidentsTempArray = [];

      // Loop on months
      for (let i = 1; i <= 12; i++) {
        // Filter data month wise from data by date / month
        const filteredIncidentsData =
          this.incidentStatistincs.incidentChartData.find(
            (incident) => incident.month === i && incident.year === this.year
          );

        const filteredAccidentsData =
          this.incidentStatistincs.accidentChartData.find(
            (incident) => incident.month === i && incident.year === this.year
          );

        // Push length of above output into array
        chartIncidentsTempArray.push(
          filteredIncidentsData ? filteredIncidentsData.count : 0
        );
        chartAccidentsTempArray.push(
          filteredAccidentsData ? filteredAccidentsData.count : 0
        );
      }

      this.$refs.barChart.updateSeries(
        [{ data: chartIncidentsTempArray }, { data: chartAccidentsTempArray }],
        true
      );
    },
  },

  computed: {
    incidentStatistincs () {
      return this.$store.getters["socket/incident"].analysis;
    },
  },

  watch: {
    incidentStatistincs: function () {
      this.generateChartData();
    },
  },

  mounted () {
    this.generateChartData();
  },
};
</script>

<style scoped>
.toolbar {
  position: relative;
}
</style>
